import service from '@/services/superaccess'

const authorization = {
  state: {
    authorization: [],
    clicked: false,
    validated: false,
    idx_car: 0,
    validate_email: true
  },
  mutations: {
    setAuthorization (state, authorization) {
      state.authorization = authorization
    },
    setClicked (state, value) {
      state.clicked = value
    },
    setValidated (state, value) {
      state.validated = value
    },
    setIdxCar (state, value) {
      state.idx_car = value
    },
    setValidateEmail (state, value) {
      state.validate_email = value
    }
  },
  getters: {
    getAuthorization (state) {
      return state.authorization
    },
    getClicked (state) {
      return state.clicked
    },
    getValidated (state) {
      return state.validated
    },
    getIdxCar (state) {
      return state.idx_car
    },
    getValidateEmail (state) {
      return state.validate_email
    }
  },
  actions: {
    retrieveData (context, payload) {
      return service.post('/api/authorization/list', context, { data: payload })
    },
    createAuthorization (context, payload) {
      return service.post('/api/authorization/create', context, { authorization: payload })
    },
    changeAuthorization (context, payload) {
      return service.put('/api/authorization/change', context, { data: payload })
    },
    showAuthorization (context, payload) {
      return service.post('/api/authorization/show', context, { id: payload })
    },
    showAuthorizationList (context, payload) {
      return service.post('/api/authorization/showAuthorizationList', context, { identification_number: payload })
    },
    editAuthorization (context, payload) {
      return service.put('/api/authorization/modify', context, { authorization: payload })
    },
    editAuthorizationGroup (context, payload) {
      return service.put('/api/authorization/modify', context, payload)
    },
    generateDepartureOrder (context, payload) {
      return service.post('/api/authorization/departure_order/generate', context, { data: payload })
    },
    createAuthorizationOverlap (context, payload) {
      return service.post('/api/authorization/create_overlap', context, { authorization: payload.authorization, authos: payload.authos })
    },
    createAuthorizationMultiple (context, payload) {
      return service.post('/api/authorization/create_multiple', context, { authorizations: payload })
    },
    getGenerateFile (context, payload) {
      return service.download(`/api/authorization_list/${payload}`, context)
    },
    getObservationsAuthorizationCargo (context, payload) {
      return service.post('/api/authorization/get_observations', context, { id: payload.id })
    },
    checkPersonTemplate (context, payload) {
      return service.post('/api/biometrics/has_template', context, { data: payload })
    },
    validAuthType (context, payload) {
      return service.post('/api/authorization/valid_auth_type', context, payload)
    },
    checkDepartureOrder (context, payload) {
      return service.post('/api/authorization/check_departure_order', context, { data: payload })
    },
    setPedestrianToCargo (context, payload) {
      return service.post('/api/transform_to_cargo', context, { data: payload })
    },
    setCargoToPedestrian (context, payload) {
      return service.post('/api/revert_to_pedestrian', context, { data: payload })
    },
    getDepartureOrderData (context, payload) {
      return service.post('/api/authorization/departure_order/tracing', context, { data: payload })
    },
    renewExpirationTimeDepartureOrder (context, payload) {
      return service.post('/api/authorization/departure_order/renew_expiration_time', context, {data: payload})
    }
  }
}

export default authorization



// WEBPACK FOOTER //
// app/javascript/src/store/authorization.js